import styled from "styled-components";
import { MaterialIcon } from "../shared/MaterialIcon";

export const SearchBar = ({type = 'primary', onChange, placeholder, width = 'auto'}) => {
    return (
        <StyledSearchBar
            $type={type}
        >
            <div>
                <MaterialIcon name='search' weight={300}/>
            </div>
            <input
                
                onChange={onChange}
                type='text'
                placeholder={placeholder}
            />
        </StyledSearchBar>
    )
}

const StyledSearchBar = styled.label`
    height: 32px;
    min-height: 32px;
    max-height: 32px;
    //background: ${({theme}) => theme.colors.neutralPrimaryBorder};

    background: ${({theme, $type}) => $type === 'primary' ? theme.colors.neutralInputBackground : theme.colors.neutralPrimaryBorder};
    border: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
    border-radius: ${({theme}) => theme.cornerRadius.md};
    display: flex;

    > div
    {
        width: 40px;
        display: flex;
        align-items: center;
        justify-content: center;

        .icon
        {
            font-size: ${({theme}) => theme.iconSize.sm};
            color: ${({theme}) => theme.colors.mutedForeground};
        }
    }

    input
    {
        background: none;
        border: none;
        outline: none;
        font-size: ${({theme}) => theme.fontSize.md};
    }
`